import type { PollingApi } from 'apiConnector/polling';
import type { Observable, SchedulerLike } from 'rxjs';
import { EMPTY, interval } from 'rxjs';
import { catchError, concatAll, filter, mergeMap, timeout } from 'rxjs/operators';

import type { LightweightEvent } from '../model';

export function startPolling(
  intervalMs: number,
  polling: PollingApi,
  scheduler?: SchedulerLike,
): Observable<LightweightEvent> {
  return interval(intervalMs, scheduler).pipe(
    mergeMap(() =>
      polling.getLastPollingMessage().pipe(
        timeout(intervalMs),
        filter(events => !!events),
        concatAll(),
        catchError(_err => {
          // make sure we do not create a denial-of-service on Elasticsearch
          return EMPTY;
        }),
      ),
    ),
  );
}
